import React from "react"
import { IconWrapper, IconPathAnimated } from "shared/Styles/Icons"

const Signature = ({color, width, height}) => (
  <IconWrapper
    id="Warstwa_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 744.9 168.4"
    xmlSpace="preserve"
  >
    <g>
      <IconPathAnimated
        color={color}
        d="M302.2,72.4c5.7-4.8,11-9.5,16.4-13.9c14-11.4,28.1-22.6,42.1-33.9c0.8-0.7,1.5-1.6,2.4-2c1.8-0.8,3.8-2,5.6-1.8
		c2.7,0.3,4.1,2.9,4,5.4c0,2-0.7,4.7-2.1,5.9c-4.2,3.7-9,6.6-13.3,10.1c-10.8,8.7-21.5,17.4-32.1,26.3c-6.7,5.6-13.3,11.5-19.7,17.4
		c-1,0.9-1.7,2.9-1.5,4.2c0.9,7.5,2,15,3.3,22.5c0.2,1,1.6,2.3,2.6,2.5c16,2.7,31.9,5.2,47.9,7.8c5.9,1,11.9,1.9,17.7,3.2
		c1.4,0.3,3,1.4,3.9,2.7c1.1,1.7,0.4,2.9-1.7,3.7c-5.9,2.3-11.7,0.2-17.5-0.3c-6.9-0.6-13.8-1.9-20.7-2.7c-9.4-1.1-18.8-2-29.1-3.1
		c2.7,6.1,5.3,12,8,17.9c1.7,3.7,3.7,7.3,5.1,11.2c0.3,0.8-0.9,2.9-1.9,3.3c-3.2,1.4-7.1,0.1-9.1-3c-5.9-9.2-10.7-18.9-12.7-29.7
		c-0.4-2.2-1.2-3.4-3.5-4.1c-3.2-0.9-6.4-2.3-9.3-3.9c-8.1-4.3-13.8-13.9-6.8-23.7c0.8-1.1,1.2-2.4,2.2-4.3c-6.9,0-13.7,0.1-20.4,0
		c-20.2-0.3-40.3-0.6-60.5-0.9c-3.3-0.1-6.5-0.5-9.8-0.9c-3.2-0.4-4.7-2.8-4.9-5.7c-0.6-6.9,1.4-12.7,6.8-17.7
		c16.4-15,35.2-26.1,55.9-34.2c6.9-2.7,14-5.3,21.1-7.1c6.5-1.7,12.1,1.5,16.4,5.9c6.6,6.7,8.8,15.7,11.2,24.4
		C299.9,59.6,300.9,65.7,302.2,72.4z M287.1,87.3c1.6-2.4,4.2-4.4,4.1-6.3c-0.9-14.6-3.7-28.7-10.8-41.7c-3.4-6.2-4.9-6.7-11.1-4.5
		c-11.3,4.2-22.4,9.1-33.1,14.4c-7.5,3.7-14.6,8.3-21.4,13.2c-5.2,3.7-9.7,8.4-14.5,12.7c-0.7,0.6-1.3,1.4-2.5,2.6
		c2.3,0.3,3.9,0.7,5.4,0.7c6.7,0.1,13.3,0,20,0c17.1,0,34.2-0.1,51.3,1.6C279.6,80.7,283.2,83,287.1,87.3z M293.8,97.7
		c-2.5,1.9-5.4,4.1-4.6,6.7c0.7,2.3,3.8,3.8,5.8,5.7c0.2-0.2,0.5-0.4,0.7-0.6C295.1,105.7,294.5,101.9,293.8,97.7z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M625.6,52.1c0.3-8.2,0.7-16.3,3.8-24c0.9-2.3,2.2-4.6,3.8-6.4c2.7-2.8,6.5-1.4,7.8,2.2c1.1,3.1,0.4,6-0.5,8.9
		c-3.4,11-3.9,22.3-2.6,33.7c1.3,11,2.3,22,3.4,33c0.1,0.5,0.1,1,0.3,2.2c2.4-4,4.4-7.6,6.6-10.9c11.3-16.7,23.6-32.6,37.6-47.1
		c3.4-3.5,6.6-7.2,10.4-10.2c2.1-1.7,5.2-2.6,8-2.9c2.5-0.3,4.7,1.3,5.3,4c0.6,2.6-0.8,4.5-2.8,6.2c-6.5,5.7-13.5,11-19.1,17.4
		c-12,14-23.5,28.4-34.8,43c-3.4,4.3-5.4,9.7-8.3,15.2c1.6-0.2,2.5-0.1,3.3-0.4c13.2-3.9,26.3-8,39.5-11.8c4.8-1.4,9.7-2.4,14.7-3.1
		c7.9-1,14.6,4.2,17.2,12.3c2,6.3,3.4,12.7,5.1,19.1c0.3,1.1,0.6,2.2,0.9,3.3c0.6,1.9,1.8,2.4,3.6,1.6c1.3-0.6,2.7-1.3,4.1-1.4
		c1.1-0.1,2.9,0.2,3.2,0.9c0.6,1.1,0.6,2.9,0.1,4.1c-1.4,3.6-4.8,4.1-8,4.2c-2,0.1-4.1-0.6-6.2-1c-4.2-0.8-7.1-3.8-8-8.1
		c-1.2-5.4-2.3-10.9-3.7-16.2c-0.7-2.5-1.9-4.9-3.1-7.2c-1.7-3.1-4.6-2.3-7.3-2c-10.8,1.4-20.7,5.9-30.9,9.5
		c-7.1,2.5-14.4,4.8-22,7.4c2,4.6,0.5,10.7,6.6,13.6c0.5,0.2,1,1.2,0.9,1.8c-0.3,2.9-2.1,4.8-4.7,5.8c-2.2,0.9-3.4-0.5-4.8-1.9
		c-4.8-4.9-6.7-11.2-8.1-17.5c-2.8-12.8-5.3-25.7-7.5-38.6c-1.4-8.6-2-17.3-3-25.9c-3.6,2.8-5.3,2.5-6.7-2.1
		c-1.3-4.3-2.1-8.8-3.2-13.2c-1.8-7.3-3.1-14.7-7.3-21.1c-2-3.1-4.5-5.8-6.9-8.5c-1.7-1.9-3.6-1.6-4.9,0.5c-2.8,4.4-3,9.2-2.2,14.3
		c2,12.2,8,22.7,14,33.2c5,8.6,10.1,17.2,14.9,26c1.5,2.8,2.4,6,3.2,9.2c1.5,6.2,0.3,11.5-4.8,16c-9.4,8.3-26.4,14.3-39.4,8.2
		c-5.2-2.5-7-11.6-3.2-15.8c2.3-2.5,4.2-2.1,5.2,1.2c0.4,1.3,0.8,2.7,0.7,4c-0.4,4.9,2.4,5.6,5.5,5.2c8.1-0.9,15.6-3.5,21.9-8.9
		c2.7-2.4,4.3-5.5,2.6-9.3c-3-6.8-5.9-13.7-9.2-20.3c-6.1-12-12.9-23.6-18.7-35.8c-4.6-9.5-6.1-19.8-3.9-30.3
		c1-4.6,3.7-8.3,7.7-10.7c3.8-2.4,7.5-0.8,10.9,1.3c8.1,5.1,12.7,12.9,15.9,21.5c2.5,6.7,4.2,13.7,6.2,20.5
		C625.3,50.9,625.5,51.5,625.6,52.1z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M138.1,162.8c4.5-3.6,8.7-7.3,13.3-10.5c8-5.6,15.5-11.6,21.6-19.2c2.3-2.9,4.1-6.4,5.4-9.8c1.9-5.2-1.2-11.6-7.1-14.2
		c-7.7-3.4-15.7-6.1-23.5-9.1c-8.1-3.1-16.4-6.1-24.4-9.5c-5.7-2.4-10.2-6.6-13.2-11.9c-2.9-5.1-2.4-10.7-1.7-16.3
		c1-9,2.3-17.9,2.7-26.9c0.4-10.8-7.1-21.7-20.2-22.8c-15.5-1.3-30.3,1-44.5,6.9c-8.7,3.6-17.3,7.8-25.7,12.1
		c-2.9,1.5-5.4,4-7.7,6.4c-2.9,3.1-2.9,6.1-0.1,9.3c2.1,2.5,4.6,4.7,6.8,7.1c1.6,1.7,3.2,3.4,4.4,5.3c0.6,1,1,2.9,0.5,3.7
		C24,64.1,22,64.4,21,64c-2.4-1-4.8-2.2-6.8-3.8C8.9,55.6,3.9,51,1.1,44.2c-1.9-4.7-1.3-8.5,1.3-12.4c4.5-6.8,11.3-10.9,18.3-14.6
		c11.6-6.3,24.1-10.7,36.8-14C64.1,1.5,71,1.6,77.8,1c0.6-0.1,1.3,0.2,1.9,0.1c8.2-0.8,15.8,1.5,23.1,4.7
		c12.8,5.5,19.6,15.6,19.8,29.3c0.1,8.4-1.6,16.7-2,25.1c-0.2,4.8,0.2,9.6,0.8,14.3c0.5,3.9,3.4,6,6.7,7.9
		c11.2,6.6,23.8,9.4,35.9,13.8c5.5,2,11.1,4.2,16.1,7.3c11,6.8,14.6,19,6.7,29.5c-5.1,6.8-11.4,12.7-17.7,18.3
		c-6,5.4-12.8,10-19.3,14.9c-4.2,3.2-6.4,2.9-9.9-1.1C139.4,164.6,139,164.1,138.1,162.8z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M382,104.1c11.4,6.4,22.9,11.5,35.4,13.7c3.7,0.6,7.5,0.6,11.1-1.9c-2.4-6-6.2-11-10.3-15.9
		c-11.2-13.3-23.1-26.1-29.6-42.7c-2.5-6.4-4.7-12.7-2.4-19.8c2.4-7.3,8-10.8,15.5-8.6c14.9,4.4,24.4,13.9,27.2,29.5
		c1.5,8.2,0.8,16.2-0.9,24.3c-0.6,2.8-1.2,5.6-1.4,8.4c-0.1,1.2,0.5,2.6,1.2,3.6c3.8,6,8.1,11.7,11.6,17.9c2.5,4.4,2.9,8.1-3.6,11.9
		c-5.5,3.2-11.6,4.6-17.5,4.2c-9.5-0.6-18.7-3.5-27-8.6c-5.7-3.4-11.5-6.5-17.2-9.9c-1.6-0.9-3-2.3-4.2-3.7
		c-1.9-2.2-1.4-4.5,1.2-5.7c2.8-1.2,5.7-2.4,8.6-2.7c3.9-0.4,4.7,1.2,3,4.6C382.4,103.2,382.3,103.6,382,104.1z M415.7,80.5
		c0.9-4.8,1.9-8.7,2.3-12.7c1.2-13-2.1-21.7-15.3-25.9c-3.6-1.1-6,1.2-5.2,4.9C400.3,59.4,406.8,70,415.7,80.5z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M504.3,90.3c2,1.6,4.1,3,5.9,4.8c1.7,1.7,2.9,3.9,4.3,5.8c2.5,3.5,5.6,5.7,10.2,4.9c7.9-1.4,15.7-2.8,23.6-4.3
		c2.7-0.5,4.5-2.1,5.3-4.8c0.3-0.9,1.6-2.3,2.1-2.2c1.2,0.3,2.5,1.2,3.2,2.3c2.4,4,0.8,9.6-3.1,12.1c-7,4.6-14.4,8.4-22.8,9.7
		c-9.3,1.6-17.6-0.7-24.4-7.4c-3-3-5.7-6.4-9-10.2c-2,4.6-3.8,9.2-6.1,13.6c-2.4,4.6-5.1,9.1-7.9,13.5c-1.5,2.4-3.9,3.6-6.8,2.1
		c-3.3-1.7-4.4-4.1-3-7.6c2-4.7,4.4-9.3,6.9-13.8c3.7-6.9,7.6-13.8,11.3-20.7c1.3-2.5,2.8-4.5,6.1-4c3.1,0.5,2.9,3.2,3.4,5.4
		c0.1,0.4,0.2,0.8,0.3,1.2C503.9,90.6,504.1,90.4,504.3,90.3z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M63.5,18.2c5-3.3,10.4,1.3,11.1,6c2.7,17.6,5.9,35.1,9,52.6c2.7,14.9,5.8,29.7,8.5,44.7c1.6,9.1,2.6,18.3,3.9,27.4
		c0.3,2.2-0.5,3.4-2.9,4c-3,0.7-4.6-0.7-5.2-3.1c-1.1-4.4-1.8-8.8-2.5-13.2c-2.4-14.9-4.5-29.8-7.3-44.6
		c-3.8-20.3-8.2-40.6-12.3-60.9C64.9,26.9,64.3,22.6,63.5,18.2z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M257.9,131.7c-4.9-1.2-9.7-2.2-14.5-3.4c-12.7-3.1-25.1-6.9-36.7-13.2c-5.7-3.1-9.7-7.9-11.6-14.1
		c-0.7-2.3,0.1-4.2,2.1-5.7c2.3-1.7,4.5-0.9,6.3,0.6c3,2.6,5.9,5.3,8.5,8.4c4.1,4.8,9.7,7.3,15.2,9.6c5.7,2.4,11.9,3.9,17.9,5.5
		c3,0.8,6.2,1.3,9.3,1.7c4.1,0.5,7.4,2.2,9.5,5.8c1.2,2,0.6,3.2-1.4,3.8C261,131.1,259.4,131.4,257.9,131.7z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M537.1,69.9c-1.1-1.1-2.7-1.9-3.3-3.3c-3-6.8-6.2-13.6-8.3-20.7c-2.7-9-4.7-18.3-6.7-27.5c-0.9-4.2-0.9-8.6-1-12.9
		c-0.1-2.9,2.8-5.5,5.7-5.6c5.2-0.2,11.4,6.6,9.1,10.7c-2,3.4-1.8,6.7-1.3,10c1.7,12.2,3.9,24.3,5.8,36.4c0.6,4,0.9,8.1,1.4,12.1
		C538,69.4,537.6,69.7,537.1,69.9z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M463.3,121.4c1.7-0.9,3.5-2,5.3-3c2.7-1.5,4.1-0.6,4.3,2.4c0.3,4.6-5.4,9.2-9.4,9.4c-2.8,0.1-5.8-0.3-8.5-1.3
		c-3.1-1.1-3.7-4.4-3.7-7.2c0-9.3,0.4-18.7,0.7-28c0.1-2.3,1.4-3.9,3.8-4.5c2.4-0.5,4.6,0.3,5.6,2.5c0.9,1.9,1.7,4.1,1.8,6.2
		C463.5,105.6,463.3,113.3,463.3,121.4z"
      ></IconPathAnimated>
      <IconPathAnimated
        color={color}
        d="M744.9,51.8c-0.4,2.3-0.6,4.4-1.1,6.4c-0.6,2.9-2.1,3.4-4.8,1.8c-6.6-3.8-8.6-10-9.4-16.9c-0.3-3.1-0.7-6.1-0.7-9.2
		c0-2.7,2-3.8,4.4-4.1c2.5-0.3,4.9,0.3,5.9,2.7c1.7,4,3,8.2,4.3,12.4C744.2,47.2,744.5,49.6,744.9,51.8z"
      ></IconPathAnimated>
    </g>
  </IconWrapper>
)

export { Signature }
